// Componente ThemeToggleButton
// Botón reutilizable para controlar el modo oscuro/claro

import React from 'react';
import { FiSun, FiMoon } from 'react-icons/fi';
import { useTheme } from '../../context/ThemeContext';
import Button from './Button';

/**
 * Componente ThemeToggleButton
 * 
 * Botón para alternar entre modo claro y oscuro
 * Contiene su propia lógica de estado mediante el hook useTheme
 * Muestra íconos diferentes según el estado actual del tema
 * 
 * @param {string} className - Clases CSS adicionales
 * @param {string} title - Texto del tooltip (opcional, se genera automáticamente si no se proporciona)
 */
const ThemeToggleButton = ({ 
  title,
  ...props 
}) => {
  // Obtiene el estado y función del tema directamente del contexto
  const { isDark, toggleTheme } = useTheme();
  
  // Genera título automáticamente si no se proporciona
  const buttonTitle = title || (isDark ? "Cambiar a modo claro" : "Cambiar a modo oscuro");

  return (
    <Button
      onClick={toggleTheme}
      variant="outline"
      className='border-none bg-neutral-100 dark:bg-neutral-800'
      title={buttonTitle}
      {...props}
    >
      {isDark ? (
        <FiSun className="h-5 w-5 text-gray-400" />
      ) : (
        <FiMoon className="h-5 w-5 text-gray-500" />
      )}
    </Button>
  );
};

export default ThemeToggleButton;
